import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const NetworkPOPRoutes = defineRoute({
    record: {
        route: {
            path: "/network-pop",
            component: () => loadView(import("./NetworkPOPTable.vue")),
        },
    },
    create: {
        route: {
            path: "/network-pop/create",
            component: () => loadView(import("./NetworkPOPCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/network-pop/update/:id",
            component: () => loadView(import("./NetworkPOPUpdate.vue")),
        },
        build(id: string) {
            return `/network-pop/update/${id}`;
        },
    },
});
